require('string-format');

// var SceneManager = require('./scene-manager').SceneManager;
import {LoadScene} from './loadscene';
import {PopupScene} from './popupscene';
import Init from './init';
import SETTINGS from "settings";
import Space from './frp/space'
import Stream from './frp/stream'
import PIXI_video_performance_fix from "PIXI_video_performance_fix"
import Server$ from "./network/net";
import ErrorDriver from "./error";
import { cancelCaching, trans_url } from 'res'

import uiConfigDefaultXGA from "./cfg/userinterface-config";
import uiConfigDefaultSVGA from "./cfg/userinterface-config_800x600";
import uiMobileConfigDefaultSVGA from "./cfg/userinterface_mobile-config_800x600";
import uiMobileConfigDefaultXGA from "./cfg/userinterface_mobile-config";

import pjConfig from "./cfg/progressive_jackpot_config";

import Server from "./network/network_api";
import DullServer from './network/dull_server'
import { cookies } from "./network/request"
import { Image, UrlParamsToObject, in_iframe, get_prop, canFullscreen, canScreenLock, is_fullscreen } from "utils"
import load from 'load'
//Sounds не используется но нужно для того чтобы инициализировалась глобальная переменная:
import Sounds from 'sounds'
import bundles from 'bundles'

import ears, { ear_url } from 'ears'

import {NoSleep} from './vendor/my_no_sleep'

import facebook from 'social/facebook'

const url_params = UrlParamsToObject()
if ( url_params[ 'nolobby' ] ) SETTINGS.nolobby = true
SETTINGS.url_params = url_params

const hand_url = 'res/common/mobile/tapToFullscreen.png'
const swapHand_url = 'res/common/mobile/swapToFullscreen.png'

const runInIOS = ( !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) ) //&& (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/));
let need_fullscreen = (canFullscreen() || runInIOS) && url_params[ 'fullscreen' ] != 0

let stage
let ears_container
let game_container
let popupScene
let uiAdaptiveContainer
let backgroundAdaptiveContainer

export const SCREEN_RATIO_1 = 16 / 9
export const SCREEN_RATIO_2 = 4 / 3

SETTINGS.preserve_resource_format = SETTINGS.preserve_resource_format || []
SETTINGS.preserve_resource_format.push(
    'common/new_ui/userinterface_1024x768_new',
    'common/new_ui/jp_panel_font',
    ear_url,
    hand_url,
    swapHand_url
)

const COMMON_HOWLER_RESOURCES = SETTINGS.load_sounds || [
    'res/common/sounds/clock_tick',
];


function getUserInterfaceResources(config, mobile) {

    if ( SETTINGS.user_interface && !mobile ) return SETTINGS.user_interface;

    if (SETTINGS.ui_mobile_resource && mobile) return SETTINGS.ui_mobile_resource;

    if (mobile) {
        const mobileFonts = [
            'res/common/mobile/fonts/ui_mobile_main_font.xml',
            'res/common/mobile/fonts/ui_mobile_panel_font.xml',
            'res/common/mobile/fonts/ui_mobile_win_font.xml',
            'res/common/mobile/fonts/mjp_bronze_font.xml',
            'res/common/mobile/fonts/mjp_green_font.xml',
            'res/common/mobile/fonts/mjp_gold_font.xml',
            'res/common/mobile/fonts/mjp_white_font.xml',
        ];
        switch (config.resolution.width) {
            default:
            case 1024:
                return mobileFonts.concat(['res/common/mobile/ui_mobile_1024x768_0.json', 'res/common/mobile/ui_mobile_1024x768_1.json', 'res/common/mobile/menu_panel.jpg']);
            case 800:
                return mobileFonts.concat(['res/common/mobile/ui_mobile_1024x768_0.json', 'res/common/mobile/ui_mobile_1024x768_1.json', 'res/common/mobile/menu_panel.jpg']);
        }
    }

    switch ( config.resolution.width ) {
        default:
        case 1024:
            return [
                'res/common/new_ui/userinterface_1024x768_new.json',
                'res/common/new_ui/userinterface1024x768-font.xml',
                'res/common/new_ui/userinterface1024x768_win-font.xml',
                'res/common/new_ui/jp_panel_font.xml',
            ]
        case 800:
            return [
                'res/common/new_ui/userinterface_800x600_new.json',
                'res/common/new_ui/userinterface800x600-font.xml',
                'res/common/new_ui/userinterface800x600_win-font.xml',
                'res/common/new_ui/jp_panel_font_800x600.xml',
            ]
    }
    
}

// prevent context menu on production
// it is the only place the jQuery included on
if (NODE_ENV == "production") {
    $(document).on("contextmenu", function (event) { event.preventDefault(); });
}

/** Растянуть игру на весь экран с сохранением пропорций и отцентровать.*/
function fit( width, height, ratio, screen_config ) {
    //change the ratio of the canvas based on current window size to resize it:
    let w, h;

    if ( width / height >= ratio ) {
        w = height * ratio
        h = height
    }
    else {
        w = width
        h = width / ratio
    }

    // cut all outside of resolution area
    const maskGameContainer = game_container.mask;
    maskGameContainer.clear();
    maskGameContainer.beginFill(0xFFFFFF);
    maskGameContainer.drawRect(0, 0, screen_config.resolution.width, screen_config.resolution.height);
    maskGameContainer.endFill();

    game_container.scale.set(
        w / screen_config.resolution.width,
        h / screen_config.resolution.height
    )

    //центровка:
    game_container.x = ( width - w ) / 2
    game_container.y = ( height - h ) / 2

    if ((SETTINGS.isMobile || SETTINGS.isEnableAdaptiveContainers) && uiAdaptiveContainer && backgroundAdaptiveContainer) {
        let screenWidth = 1024;
        let screenHeight = 768;
        if (SETTINGS.isUseScreenConfigForAdaptiveContainerScale) {
            screenWidth = screen_config.resolution.width;
            screenHeight = screen_config.resolution.height;
            if (SETTINGS.transparent_render) {
                if (width / height <= ratio) {
                    h = height
                }
            }
        }
        uiAdaptiveContainer.x = 0;
        uiAdaptiveContainer.y = ( height - h ) / 2
        uiAdaptiveContainer.scale.set(
            width / screenWidth,
            h / screenHeight
        );

        backgroundAdaptiveContainer.scale.set(
            width / screenWidth,
            h / screenHeight
        );
    }

    return {
        x : w,
        y : h,
        dx : game_container.x,
        dy : game_container.y,
    }
}

/** Растянуть игру на весь экран БЕЗ сохранений пропорций, занимая всё доступное пространство.*/
function stretch( width, height ) {
    //пока что рефакторится использование PIXI в HTML, обойдёмся без stretch() - всё-равно никто не помнит как он должен работать и для чего делался (да и акцент сейчас на мобилки где stretch()'а быть не должно):
    return { x : width, y : height }
}

//определяем яблочный девайс по характеристикам экрана
// решение взято из билиотеки Scream js (https://github.com/gajus/scream)
/**
 * Detects if iOS version equals 13
 * Only works for iPhone.
 * @see https://forums.developer.apple.com/thread/119186
 */
const isIOS13 = () => {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return parseInt(v[1]) === 13;
    }

    return false;
};

/**
 * @property 0 window.innerWidth when device is in a portrait orientation, scale 0.25 and page is the minimal view
 * @property 1 window.innerHeight when device is in a portrait orientation, scale 0.25 and page is the minimal view
 * @property 2 window.innerWidth when device is in a landscape orientation, scale 0.25 and page is the minimal view
 * @property 3 window.innerHeight when device is in a landscape orientation, scale 0.25 and page is the minimal view
 * @property 4 screen.width
 * @property 5 screen.height
 * @property 6 devicePixelRatio
 * @property 7 name
 */
/**
 * Uses static device environment variables (screen.width, screen.height, devicePixelRatio) to recognize device spec.
 */
function deviceSpec() {
    let index,
        spec;

    const specsPreIOS13 = [
        [1280, 1762, 1920, 1280, 320, 480, 2, 'iPhone 4/4s'],
        [1280, 2114, 2272, 1280, 320, 568, 2, 'iPhone 5/5c/5s/SE and 6/6s (Zoomed)'],
        [1500, 2510, 2668, 1500, 375, 667, 2, 'iPhone 6/6s/7/8'],
        [1656, 2785, 2944, 1656, 414, 736, 3, 'iPhone 6+/6s+/7+/8+'],
        [1500, 2509, 2668, 1500, 375, 667, 3, 'iPhone 6+/6s+/7+/8+ (Zoomed)'],

        [3072, 3936, 4096, 2912, 768, 1024, 1, 'iPad 2'],
        [3072, 3938, 4096, 2914, 768, 1024, 2, 'iPad Air/Retina/Pro (9.7-inch)'],
        [3336, 4290, 4448, 3178, 834, 1112, 2, 'iPad Pro (10.5-inch)'],
        [3336, 4602, 4776, 3162, 834, 1194, 2, 'iPad Pro (11-inch)'],
        [4096, 5306, 5464, 3938, 1024, 1366, 2, 'iPad Pro (12.9-inch)'],
        [4096, 5290, 5464, 3922, 1024, 1366, 2, 'iPad Pro (12.9-inch) 3rd generation'],

        [1656, 3330, 3584, 1656, 414, 896, 2, 'iPhone XR'],
        [1500, 2993, 3248, 1500, 375, 812, 3, 'iPhone X/XS'],
        [1656, 3329, 3584, 1656, 414, 896, 3, 'iPhone XS Max']
    ];

    const specsIOS13 = [
        [1280, 1764, 1920, 1280, 320, 480, 2, 'iPhone 4/4s (iOS 13)'],
        [1280, 2116, 2272, 1280, 320, 568, 2, 'iPhone 5/5c/5s/SE and 6/6s (Zoomed) (iOS 13)'],
        [1500, 2512, 2668, 1500, 375, 667, 2, 'iPhone 6/6s/7/8 (iOS 13)'],
        [1656, 2788, 2944, 1656, 414, 736, 3, 'iPhone 6+/6s+/7+/8+ (iOS 13)'],
        [1500, 2512, 2668, 1500, 375, 667, 3, 'iPhone 6+/6s+/7+/8+ (Zoomed) (iOS 13)'],

        [3072, 3940, 4096, 3166, 768, 1024, 2, 'iPad Air/Retina/Pro (9.7-inch) (iOS 13)'],
        [3336, 4276, 4448, 3164, 834, 1112, 2, 'iPad Pro (10.5-inch) (iOS 13)'],
        [3336, 4604, 4776, 3164, 834, 1194, 2, 'iPad Pro (11-inch) (iOS 13)'],
        [4096, 5308, 5464, 3940, 1024, 1366, 2, 'iPad Pro (12.9-inch) (iOS 13)'],
        [4096, 5292, 5464, 3924, 1024, 1366, 2, 'iPad Pro (12.9-inch) 3rd generation (iOS 13)'],

        [1656, 3332, 3584, 1656, 414, 896, 2, 'iPhone XR (iOS 13)'],
        [1500, 2996, 3248, 1500, 375, 812, 3, 'iPhone X/XS (iOS 13)'],
        [1656, 3332, 3584, 1656, 414, 896, 3, 'iPhone XS Max (iOS 13)'],
    ];

    const specs = isIOS13() ? specsIOS13 : specsPreIOS13;
    index = specs.length;

    while (index--) {
        if (window.screen.width === specs[index][4] &&
            window.screen.height === specs[index][5] &&
            window.devicePixelRatio === specs[index][6]) {
            spec = specs[index];

            break;
        }
    }

    return spec;
}

function getOrientation() {
    return window.orientation === 0 || window.orientation === 180 ? 'portrait' : 'landscape';
}

function initScreen( screenConfig, space ) {

    if (runInIOS) {
        need_fullscreen = need_fullscreen && !SETTINGS.no_iOS_fullscreen;
    }

    PIXI.renderer = PIXI.autoDetectRenderer(
        SETTINGS.canvas.width,
        SETTINGS.canvas.height,
        {
            antialias : false,
            transparent : (SETTINGS && SETTINGS.transparent_render !== undefined) ? SETTINGS.transparent_render :  false,
            resolution: window.devicePixelRatio || 1,
            autoResize:true,
            //может уменьшить разрывы между текстурами при скейлинге основного контейнера с игрой
            roundPixels: SETTINGS.roundPixels || false,
            //trying to fix flickering on android devices:
            preserveDrawingBuffer : true,
            backgroundColor : 0x011B22,
            legacy : ( SETTINGS.pixi_legacy ? ( ( SETTINGS.pixi_legacy instanceof Function ) ? SETTINGS.pixi_legacy() : SETTINGS.pixi_legacy ) : false ),
        }
    );
    PIXI.renderer.plugins.interaction.autoPreventDefault = true// false

    stage = new PIXI.Container

    if ( ! SETTINGS.enable_sleep ) {
        no_sleep(stage)
    }

    if ( ! SETTINGS.no_ears ) {
        ears_container = new PIXI.Container
        stage.addChild( ears_container )
    }

    SETTINGS.ROOT_CONTAINERS = {};

    if ( SETTINGS.isMobile || SETTINGS.isEnableAdaptiveContainers ) {
        backgroundAdaptiveContainer = new PIXI.Container();
        backgroundAdaptiveContainer.interactive = true;
        stage.addChild(backgroundAdaptiveContainer)

        SETTINGS.ROOT_CONTAINERS.background_adaptive_container = backgroundAdaptiveContainer;
    }

    game_container = new PIXI.Container
    stage.addChild( game_container )
    space.s( 'screen_ratio_sink' ).to( space.s( 'screen_ratio' ) )
    space.s( 'screen_ratio_sink' ).next( SETTINGS.screen.screen_ratio || SCREEN_RATIO_1 )
    console.log( 'canvas:', SETTINGS.canvas, 'resolution:', screenConfig.resolution )

    SETTINGS.ROOT_CONTAINERS.game_container = game_container;

    const maskGameContainer = new PIXI.Graphics();
    maskGameContainer.beginFill(0xFFFFFF);
    maskGameContainer.drawRect(0, 0, screenConfig.resolution.width, screenConfig.resolution.height);
    maskGameContainer.endFill();
    game_container.addChild(maskGameContainer);
    game_container.mask = maskGameContainer;

    document.body.insertBefore(PIXI.renderer.view, document.body.firstChild);

    if ( SETTINGS.isMobile || SETTINGS.isEnableAdaptiveContainers ) {
        uiAdaptiveContainer = new PIXI.Container();
        uiAdaptiveContainer.interactive = true;
        stage.addChild( uiAdaptiveContainer )

        SETTINGS.ROOT_CONTAINERS.ui_adaptive_container = uiAdaptiveContainer;
    }

    if ( SETTINGS.isMobile && ! SETTINGS.custom_init ) {

        const compareHeightValue = () => {
            if (window.innerWidth > window.innerHeight) {
                return Math.min(window.screen.availWidth, window.screen.availHeight);
            }
            else {
                return Math.max(window.screen.availWidth, window.screen.availHeight);
            }
        }

        // этот код нужен только для определения того, что мы находимся в режиме минимального интерфейса в safari
        const iOSSpec = deviceSpec();

        if (iOSSpec) {
            console.log('#SPEC device: ', iOSSpec[7]);
        }
        else {
            console.log('#SPEC device: undefined');
        }

    //* @see http://stackoverflow.com/questions/26827822/how-is-the-window-innerheight-derived-of-the-minimal-view/26827842
    //* @see http://stackoverflow.com/questions/26801943/how-to-get-the-window-size-of-fullscream-view-when-not-in-fullscream
        const getMinimalViewHeight = () => {
            let height;

            const orientation = getOrientation();

            if (!iOSSpec) {
                return
            }

            if (orientation === 'portrait') {
                height = Math.round(window.screen.width * iOSSpec[1] / iOSSpec[0]);
            } else {
                height = Math.round(window.screen.height * iOSSpec[3] / iOSSpec[2]);
            }

            return height;
        };

        const isMinimalView = () => {
            if (iOSSpec) {
                // It is enough to check the height, because the viewport is based on width.
                return window.innerHeight + 25 >= getMinimalViewHeight();
            }
            else {
                let delta = 50;
                return (window.innerHeight + delta) >= compareHeightValue();
            }
        };

        const docEl = window.document.documentElement;

        let when_hide_tap
        const hand = Image( hand_url )
        const swapHand = Image(swapHand_url);
        const do_tap = new PIXI.Container;
        const do_tap_background = new PIXI.Graphics;

        const resizeHand = (width, height) => {
            let scale = 1;
            let scaleSwap = 1;
            if (width > height) {
                scale = (0.4*width)/219
                scaleSwap = (0.3*width)/219
            }
            else {
                scale = (0.45*height)/224
                scaleSwap = (0.35*height)/224
            }
            hand.scale.set(scale);
            hand.position.x = width / 2 - hand.width / 2
            hand.position.y = height / 2 - hand.height / 2

            swapHand.scale.set(scaleSwap);
            if (swapHand.height > height) {swapHand.height = height}
            swapHand.position.x = width / 2 - swapHand.width / 2
            swapHand.position.y = height / 2 - swapHand.height / 2

            if ( do_tap.visible ) {
                do_tap_background.clear()
                do_tap_background.beginFill(0x000000, 0.85)
                do_tap_background.drawRect(0, 0, window.innerWidth, window.innerHeight)
                do_tap_background.endFill()
            }
        }

        const $showTapScreen = space.s('show_tap_screen');

        // константа для сравнения доступной высоты экрана с общей высотой на IOS устройствах
        // к сожалению, может сильно измениться при выходе новых устройств, но другой способ пока мной не придуман
        const compareDeltaForIOS = 65;

        if ( need_fullscreen )
        {

            //чёрная заглушка экрана с изображением руки, требующая игрока тапнуть по экрану чтобы экран повернулся и перешёл в fullscreen:
            stage.addChild( do_tap )
            do_tap.interactive = true
            do_tap.tap = () => {
                hand.visible = false;
                space.s( 'try_toggle_fullscreen' ).next();
            }
            // const do_tap_background = new PIXI.Graphics
            // $ticker_seconds.on( () => {
            //     if ( ! do_tap.visible ) return
            //     do_tap_background.clear()
            //     do_tap_background.beginFill( 0x000000, 0.85 )
            //     do_tap_background.drawRect( 0, 0, window.innerWidth, window.innerHeight )
            //     do_tap_background.endFill()
            // } )
            do_tap.addChild( do_tap_background )

            do_tap.addChild( hand )
            do_tap.addChild(swapHand);

            swapHand.visible = false;//runInIOS;
            hand.visible = !runInIOS;


            space.s( 'change_screen' ).on( screen => {
                let w = screen.w;
                let h = screen.h;

                // if ( ! do_tap.visible ) return
                // do_tap_background.clear()
                // do_tap_background.beginFill( 0x000000, 0.85 )
                // do_tap_background.drawRect( 0, 0, w, h )
                // do_tap_background.endFill()

                space.s( 'change_to_vertical' ).next((h > w))
            } )

            space.s( 'change_to_vertical' )
                .distinctUntilChanged()
                .withLatestFrom(space.s( 'change_screen' ), (_, screen) => screen)
                .on(screen => {
                    resizeHand(screen.w, screen.h);
                })

            space.s( 'change_screen' )
                .any( space.s( 'landscape' ), space.s( 'need_fullscreen' ), ( _1, _2, nf ) => nf )
                .on( nf => {

                    if (runInIOS) {
                        do_tap.visible = false;
                        if (nf && !isMinimalView()/*(window.innerHeight + compareDeltaForIOS) < compareHeightValue()*/) {
                            // window.scrollTo(0, 0);
                            when_hide_tap = undefined
                            do_tap.alpha = 1
                            do_tap.visible = true
                            swapHand.visible = true
                            PIXI.renderer.plugins.interaction.autoPreventDefault = false;
                            resizeHand(window.innerWidth, window.innerHeight);
                            $showTapScreen.next(true);
                        }
                        else {
                            PIXI.renderer.plugins.interaction.autoPreventDefault = true;
                            do_tap.visible = false;
                            swapHand.visible = false;
                            $showTapScreen.next(false);
                        }
                    }
                    else {
                        if (is_fullscreen()) {
                            when_hide_tap = new Date;
                            hand.visible = false;
                            $showTapScreen.next(false);
                        }
                        else {

                            when_hide_tap = undefined

                            if (nf) {
                                resizeHand(window.innerWidth, window.innerHeight);
                                do_tap.alpha = 1;
                                do_tap.visible = true;
                                hand.visible = true;
                                $showTapScreen.next(true);
                            }
                        }
                    }

                } )
            
            space.s( 'ticker' )
                .on( () => {
                    if ( when_hide_tap ) {
                        const GAP = 500
                        const alpha = ( GAP - ( ( new Date ) - when_hide_tap ) ) / GAP
                        do_tap.alpha = Math.max( alpha, 0 )
                        if ( alpha <= 0 ) {
                            when_hide_tap = undefined
                            if ( is_fullscreen() ) {
                                do_tap.visible = false
                                space.s( 'screen_change' ).next()
                            }
                        }
                    }
                } )

            space.s('goToLobby').on(() => {
                do_tap.visible = true;
                do_tap.alpha = 1;
                hand.visible = false;
                swapHand.visible = false;
            })
            //выходим из фкллскрина при выходе в лобби, что бы избежать проблем с дальнейшими запусками сразу в фс
            space.s('goToLobby').map(() => false).to(space.s( 'need_fullscreen' ));
            space.s('goToLobby').map(() => false).to(space.s('need_resize'));
        }

        if (runInIOS) {

            docEl.style.height = '140%';
            docEl.style.position = 'static';

            if (need_fullscreen) {

                //решение проблем с ios13, когда события тача не пропускались через renderer.view
                docEl.style.overflowY = 'scroll';
                docEl.style.webkitOverflowScrolling = 'touch';
                PIXI.renderer.view.style.touchAction = 'auto';

                //убирает обрезание renderer.view при скроллинге
                window.document.body.style.height = '120%';

                //возвращаем полосу сколла на верх по окончанию
                window.addEventListener("touchend", () => {
                    window.scrollTo(0, 0)
                });

                // window.scrollTo(0, 0);
                if (/*window.innerHeight < compareHeightValue()*/!isMinimalView()) {
                    PIXI.renderer.plugins.interaction.autoPreventDefault = false;
                    do_tap.visible = true;
                    swapHand.visible = true;
                    $showTapScreen.next(true);
                }

                window.onscroll = () => {

                    let scroll = window.pageYOffset || document.documentElement.scrollTop;
                    // console.log('#--SCROLLING--')
                    // console.log(window.innerHeight, " ", compareHeightValue(), " ", scroll)
                    if (/*(window.innerHeight + compareDeltaForIOS) >= compareHeightValue()*/isMinimalView() /*&& scroll >= 40*/) {
                        PIXI.renderer.plugins.interaction.autoPreventDefault = true;
                        do_tap.visible = false;
                        swapHand.visible = false;
                        $showTapScreen.next(false);
                        //window.scrollTo(0, 0);
                    }
                }
            }
        }

    }

    const $screen_change = space.s( 'screen_change' )
    window.addEventListener( 'resize', () => $screen_change.next() );
    window.addEventListener( 'orientationchange', () => $screen_change.next() )
    setInterval( () => $screen_change.next(), 100 )

    space.s( 'need_fullscreen' ).to($screen_change)
    const $screen_ratio_change = space.s( 'screen_ratio' ).changed()
    $screen_ratio_change.to( $screen_change )
    $screen_ratio_change.to( space.s( 'screen_ratio_source' ) )
    
    space.s( 'landscape' ).next(
        canScreenLock()
        &&
        ! url_params[ 'no_orientation_lock' ]
        &&
        ! SETTINGS.lock_portrait
    )

    let w
    let h
    let o
    let r

    // видимо нам иногда понадобится отключать ресайз
    const $need_resize = space.s('need_resize');
    $need_resize.next(true)

    $screen_change
        .with( space.s( 'landscape' ), space.s( 'screen_ratio' ), $need_resize, ( _, landscape, screen_ratio, need_resize ) => ({ landscape, screen_ratio, need_resize }) )
        .filter(({need_resize}) => need_resize || w !== window.innerWidth)
        .do( ({ landscape }) => {
            //you can attempt locking orientation ONLY when it's in fullscreen:
            if ( landscape && is_fullscreen() ) {
                try {
                    const promise = window.screen.orientation.lock( SETTINGS.lock_portrait ? 'portrait' : 'landscape' )
                    promise.catch(() => {})
                } catch (e) {}
            }
        } )
        .map( ({ screen_ratio}) => ({
            w : window.innerWidth,
            h : window.innerHeight,
            o : window.orientation || 0,
            r : screen_ratio,
        }) )
        .filter( new_screen => new_screen.w != w || new_screen.h != h || new_screen.o != o || new_screen.r != r )
        .do( new_screen => {

            if (runInIOS && (window.pageYOffset || document.documentElement.scrollTop) > 0 ) {
                window.scrollTo(0, 0);
            }

            w = new_screen.w
            h = new_screen.h
            o = new_screen.o
            r = new_screen.r

            PIXI.renderer.resize( w, h )
        } )
        .map( () => ({ w, h, o }) )
        .to( space.s( 'change_screen' ) )

    space.s( 'screen_config' ).next( {resolution: {width: screenConfig.resolution.width, height: screenConfig.resolution.height}} );

    if ( SETTINGS.no_default_screen_handler ) {
        space.s( 'change_screen' ).to( space.s( 'resize' ) )
    }
    else {
        space.s( 'change_screen' )
            .with( space.s( 'screen_ratio' ),  space.s( 'screen_config' ), ( { w, h }, screen_ratio, screen_config ) => ({ w, h, screen_ratio, screen_config }) )
            .map( ({ w, h, screen_ratio, screen_config }) => {
                let do_stretch = (STRETCH_ENV !== 'false' && !SETTINGS.isMobile);

                //пока что рефакторится использование PIXI в HTML, обойдёмся без stretch() - всё-равно никто не помнит как он должен работать и для чего делался (да и акцент сейчас на мобилки где stretch()'а быть не должно):
                do_stretch = false

                //дизайнерское требование запретить растягивать игру по вертикали больше чем по горизонтали:
                // if ( w / h < config.resolution.width / config.resolution.height) {
                if ( w / h < SETTINGS.canvas.width / SETTINGS.canvas.height ) {
                    do_stretch = false;
                }
                
                if ( do_stretch ) return stretch( w, h )
                else return fit( w, h, screen_ratio, screen_config )
            } )
            .to( space.s( 'resize' ) )
    }
    
    $screen_change.next( true )
    
    //unlock orientation when user doesn't want it:
    space.s( 'landscape' )
        .filter( landscape => ! landscape )
        .on( () => window.screen.orientation.unlock() )
}

let lastTime = Date.now()
let $ticker_seconds
let skipped = 0
function animate_and_update( space )
{
    requestAnimationFrame( () => animate_and_update( space ) )
    
    if ( SETTINGS.power_savings && space.s( 'tab_visibility' ).value === false ) return
    
    if ( SETTINGS.skip_frames > 0 ) {
        ++ skipped
        if ( skipped <= SETTINGS.skip_frames ) return
        skipped = 0
    }
    
    try
    {
        if ( PIXI && PIXI.renderer ) PIXI.renderer.render( stage )
    }
    catch ( e )
    {
        console.error( 'PIXI render fail:', e )
    }
    
    TWEEN.update( performance.now() )
    
    const now = Date.now()
    const dt = now - lastTime
    
    lastTime = now
    $ticker_seconds.next( dt / 1000 )
}

function InitFullScreenSettings( space ) {

    if (SETTINGS.isMobile)
    {
        space.s( 'need_fullscreen' ).next( need_fullscreen )
        
        const $try_toggle_fullscreen = space.s( 'try_toggle_fullscreen' )

        //when user clicks "fullscreen" button it now means changing screen ratio:
        $try_toggle_fullscreen
            .with( space.s( 'need_fullscreen' ), ( _, need_fullscreen ) => need_fullscreen )
            .filter( need_fullscreen => need_fullscreen )
            .on(() => {

                console.log("TRY ENTER FULL!!!!!!!", is_fullscreen())

                const docEl = window.document.documentElement;

                const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen;

                if (!is_fullscreen()) {
                    requestFullScreen.call(docEl)
                }
            })

        //if comment
        //when user clicks "fullscreen" button it now means changing screen ratio:
        //enter fullscreen when user clicks the button:
        space.s( 'need_fullscreen' )
            .filter( need_fullscreen => need_fullscreen )
            .to( $try_toggle_fullscreen )
        
        //exit fullscreen when user clicks the button:
        space.s( 'need_fullscreen' )
            .filter( need_fullscreen => ! need_fullscreen )
            .on( () => {
                console.log( 'EXITING FULLSCREEN' )
                const doc = window.document
                const cancelFullScreen = doc.exitFullscreen || doc.webkitExitFullscreen || doc.mozCancelFullScreen || doc.msExitFullscreen
                if (doc.fullscreenElement) {
                    cancelFullScreen.call(doc);
                }
            } )
    }
    else {

        const fullScreenButton = document.createElement('img');
        fullScreenButton.src = "../common/zoom_in.png";
        fullScreenButton.className = 'fullscreenbutton';
        document.body.appendChild(fullScreenButton);

        //this fullscreen mode detection method may not work:
        var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
        var mouseover = false

        /** Updates button's representation accordingly current display mode.*/
        function handleChange() {
            if (isFullscreen) {
                fullScreenButton.src = mouseover ? '../common/zoom_out_over.png' : "../common/zoom_out.png";
            }
            else {
                fullScreenButton.src = mouseover ? '../common/zoom_in_over.png' : "../common/zoom_in.png";
            }
        }

        $( fullScreenButton ).mouseover( () => {
            mouseover = true;
            handleChange();
        } );
        $( fullScreenButton ).mouseout( () => {
            mouseover = false;
            handleChange();
        } );

        //it seems like there is some possibility that game may be started already with fullscreen mode on:
        handleChange();

        BigScreen.onenter = function () {
            isFullscreen = true;
            handleChange();
        };
        BigScreen.onexit = function () {
            isFullscreen = false;
            handleChange();
        }

        //BigScreen still can't handle Firefox, so let's help it:
        document.addEventListener("mozfullscreenchange", function () {
            isFullscreen = document.mozFullScreen;
            handleChange();
        }, false);

        fullScreenButton.addEventListener('click', function () {
            //если просто toggle(), то для document.body, что приходит к исчезновению background'а:
            BigScreen.toggle(document.documentElement);
        }, false);
    }
}

let ga_server_reported = false
let ga_graphics_reported = false
let ga_load_reported = false

import resources_config from 'res/resources'
import gameConfig from 'cfg/game-config.js'
import versionInfo_imported from 'src/version'
import screenConfig_imported from 'cfg/screen-config'

export function main()
{
    clearTimeout( get_back_timeout )
    
    const space = new Space( 'main' )
    //online debugging:
    window.space = space
    
    facebook( space )

    //redefining configurations with default ones:
    let resources
    let construct
    let serverInfo
    let serverOptions
    let screenConfig
    let versionInfo
    let params
    if ( arguments.length > 1 )
    {
        resources = arguments[ 0 ]
        construct = arguments[ 1 ]
        serverInfo = arguments[ 2 ]
        serverOptions = arguments[ 3 ]
        screenConfig = arguments[ 5 ]
        versionInfo = arguments[ 6 ]
        if ( arguments[ 8 ] )
        {
            params = arguments[ 8 ]
            for ( const i in arguments[ 8 ] ) params[ i ] = arguments[ 8 ][ i ]
        }
        else params = {}
    }
    else
    {
        params = arguments[ 0 ] || {}
        
        resources = resources_config
        versionInfo = versionInfo_imported
        serverInfo = params.serverInfo || {
            gameNetworkId : gameConfig.gameNetworkId,
            gameName : versionInfo.name,
        }
        serverOptions = params.serverOptions || {}
        screenConfig = screenConfig_imported

        if ( params.resources_config ) {
            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }

            let tempHowler = []
            let tempPixi = []
            for (const res of params.resources_config) {
                tempHowler = tempHowler.concat(res.howler)
                tempPixi = tempPixi.concat(res.pixi)
            }
            resources.howler = resources.howler.concat(tempHowler.filter(onlyUnique))
            resources.pixi = resources.pixi.concat(tempPixi.filter(onlyUnique))
        }

        if ( params.screen_config ) {
            screenConfig = params.screen_config
        }
    }
    
    if ( params.on_space ) params.on_space( space )
    
    if ( SETTINGS.bonusUserSelectionsPolicy ) serverInfo.bonusUserSelectionsPolicy = SETTINGS.bonusUserSelectionsPolicy

    SETTINGS.serverOptions = SETTINGS.serverOptions || serverOptions
    SETTINGS.versionInfo = versionInfo

    SETTINGS.volume = SETTINGS.hasOwnProperty( 'volume' ) ? SETTINGS.volume : 0.5
    Howler.volume( SETTINGS.volume )

    bundles()

    PIXI.loaders.Resource.setExtensionLoadType( 'jp2', PIXI.loaders.Resource.LOAD_TYPE.IMAGE )
    PIXI.loaders.Resource.setExtensionXhrType( 'jp2', PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB )

    tab_visibility( space )

    SETTINGS.isMobile = MobileEsp.DetectTierIphone() || MobileEsp.DetectTierTablet();
    SETTINGS.isTablet = MobileEsp.DetectTierTablet();
    
    ga_event( 'main' );
    ga_timing( 'main' )

    $ticker_seconds = space.s( 'ticker' )
    let lastTime = Date.now()
    animate_and_update( space )
    
    const $keyboard = space.s( 'keyboard' )
    window.addEventListener( 'keydown', event => $keyboard.next( event.which ) )

    if ( ! SETTINGS.no_fullscreen && need_fullscreen ) InitFullScreenSettings( space )
    
    PIXI_video_performance_fix()
    
    SETTINGS.screen = screenConfig;
    SETTINGS.canvas = SETTINGS.canvas || { width : 1366, height : 768 };

    let server
    if ( SETTINGS.no_default_lib ) console.log( 'No default lib.' )
    if ( SETTINGS.dull_server ) SETTINGS.dull_server( space )
    const ServerClass = SETTINGS.dull_server ? DullServer : ( ( SETTINGS.no_default_lib || SETTINGS.no_server ) ? undefined : Server )
    if ( ServerClass ) server = new ServerClass(
        serverInfo.gameNetworkId,
        serverInfo.gameName || "UNDEFINED",
        serverInfo.bonusUserSelectionsPolicy,
        serverInfo.totalizator,
        space,
    )
    if ( server ) space.s( 'server' ).next( server )

    cancelCaching( versionInfo );
    
    if ( SETTINGS.isMobile ) {
        window.onerror = ( message_or_event, source, lineno, colno, error ) => {
            const txt = message_or_event +'|'+ source +'|'+ lineno +'|'+ colno +'|'+ error
            
            if ( NODE_ENV == 'development' && serverInfo.gameName != 'vendor' ) alert( txt )
            
            server && server.trace && server.trace( txt )
        }
    }

    initLog();

    if ( versionInfo ) console.log( versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate )
    else console.log( 'versionInfo is undefined' )

    load( space.child( 'load' ), trans_url )
    
    //правка связки popupScene с errorDriver из-за того что popupScene является императивной конструкцией, которая обязательно должна быть создана только после загрузки ресурсов:
    const popup_scene_storage = {}
    
    Server$( space );
    const errorDriver = ErrorDriver(
        popup_scene_storage,
        space,
        SETTINGS.serverOptions,
        server ? server.lobbyURL : undefined,
    )
    
    const onFatal = ( message, instant, redirectUrl ) => {
        server && server.trace && server.trace( message )
        
        if ( ! ga_server_reported )
        {
            ga_server_reported = true
            ga(
                'send',
                'exception',
                {
                    exDescription : message,
                    exFatal : true
                }
            )
        }
        
        errorDriver.$fatal.next( { message, instant, redirectUrl } )
    }
    
    space.s( 'load:complete' )
        .filter( c => c.bundle && c.bundle.name == 'loadscreen' )
        .map( () => true )
        .name( space, 'loadscreen_load' )
    
    //TODO: can't use function composition here due to JavaScript's functions definitions ordering (i.e. can't compose facebook loading await on top of loadscreen loading await):
    space.s( 'loadscreen_load' )
        .any( space.s( 'facebook_load' ), ( l, f ) => l && f )
        .on( () => boot( {
            resources,
            construct,
            serverOptions : SETTINGS.serverOptions,
            screenConfig,
            space,
            server,
            params,
            onFatal,
            popup_scene_storage,
            errorDriver,
        } ) )

    space.s( 'load:postpone_sounds' ).next( SETTINGS.isMobile )
    
    space.s( 'load:error' ).on( msg => onFatal(
        msg,
        false,
        //back to the lobby or just update the game:
        ( server && server.lobbyURL ) || window.location.href
    ) )

    // первоначальная загрузка элементов загрузочного экрана и служебных картинок
    let LOADSCREEN_RESOURCES
    if ( SETTINGS.load_graphics ) LOADSCREEN_RESOURCES = SETTINGS.load_graphics
    else {
        LOADSCREEN_RESOURCES = [
            'res/common/load_process_indicator.json',
            'res/common/no_connection.json',
            'res/common/connection_failed.png',

            screenConfig.loadscreen.image || 'res/loadscreen.jpg',
            screenConfig.loadscreen.loadbar.image || 'res/loadbar.png',

            ear_url,

            'res/common/mobile/tapToFullscreen.png',
            'res/common/mobile/swapToFullscreen.png',
        ]

        if (SETTINGS.ears_additional_res)
            LOADSCREEN_RESOURCES = LOADSCREEN_RESOURCES.concat(SETTINGS.ears_additional_res);
        
        if ( ! SETTINGS.no_default_lib ) {
            LOADSCREEN_RESOURCES.push(
                'res/common/progressive_jackpot/jp_ingame_panel.png',
                'res/common/progressive_jackpot/fonts/jp_bronze_font.xml',
                'res/common/progressive_jackpot/fonts/jp_green_font.xml',
                'res/common/progressive_jackpot/fonts/jp_white_font.xml',
                'res/common/progressive_jackpot/fonts/jp_gold_font.xml',
            
                'res/common/progressive_jackpot/jp_money_panel.png',
                'res/common/progressive_jackpot/fonts/jp_money_font.xml',
                'res/common/progressive_jackpot/fonts/jp_currency_font.xml',
            )
        }
    }

    if ( SETTINGS.add_load_graphics ) LOADSCREEN_RESOURCES = LOADSCREEN_RESOURCES.concat( SETTINGS.add_load_graphics )
    space.s( 'load:load' ).next( {
        name : 'loadscreen',
        graphics : LOADSCREEN_RESOURCES
    } )
}

function boot( {
    resources,
    construct,
    serverOptions,
    screenConfig,
    space,
    server,
    params,
    onFatal,
    popup_scene_storage,
    errorDriver,
} )
{
    initScreen( screenConfig, space )

    let earsAdditionalImages = [];
    if (SETTINGS.ears_additional_res)
        earsAdditionalImages = SETTINGS.ears_additional_res;

    if ( ! SETTINGS.no_ears ) ears( space, ears_container, earsAdditionalImages )

    let loadScene = SETTINGS.no_load_scene ? {} : new LoadScene( screenConfig );
    if ( loadScene.addChild ) game_container.addChild( loadScene );
    const loadscene_space = new Space
    if ( SETTINGS.on_loadscene ) SETTINGS.on_loadscene( loadscene_space, loadScene )

    if ( in_iframe() ) window.top.postMessage( "game_loading_begin", "*" )

    popupScene = SETTINGS.no_popup_scene ? {} : new PopupScene(screenConfig);
    popup_scene_storage.obj = popupScene
    if ( popupScene.addChild ) game_container.addChild( popupScene )

    if ( popupScene.showProcessIndicator ) popupScene.showProcessIndicator();

    if ( popupScene.position ) space.s( 'screen_config' )
        .changed()
        .filter( r => r )
        .on( (screenConfig) => {
            for (let child of popupScene.children) {
                child.position.set( screenConfig.resolution.width / 2, screenConfig.resolution.height / 2 )
            }
        } )

    if ( SETTINGS.no_default_screen_handler && popupScene.position ) space.s( 'resize' )
        .any( errorDriver.$isError, errorDriver.$preloader, r => r )
        .filter( r => r )
        .on( ({ w, h }) => popupScene.position.set( w / 2 - screenConfig.resolution.width / 2, h / 2 - screenConfig.resolution.height / 2 ) )

    //initialize server connection:
    const invokeHandleLobby = () => server.handleLobby(
        () => {

            console.log( 'Server communication successfully established.' )

            if ( ! ga_server_reported )
            {
                ga_server_reported = true
                ga_event( 'server_connected' );
            }
            
            if ( popupScene.hideNoConnectionBanner ) popupScene.hideNoConnectionBanner();
            if ( loadScene && loadScene.hideConnectionIndicator ) loadScene.hideConnectionIndicator();
            
            space.s( 'server_initialized' ).next( true )
        },
        error => {
            
            if ( ! ga_server_reported )
            {
                ga_server_reported = true
                ga(
                    'send',
                    'exception',
                    {
                        exDescription : error,
                        exFatal : false
                    }
                )
            }
            
            console.error( 'Failed to handle lobby: ' + error );
            if ( popupScene.showNoConnectionBanner ) popupScene.showNoConnectionBanner();
            if ( popupScene.hideProcessIndicator ) popupScene.hideProcessIndicator();

            invokeHandleLobby();
        },
        onFatal,
        serverOptions
    );
    if ( server ) invokeHandleLobby();
    //временно, пока во всех играх без WBG не перешли на новый библиотечный сервер:
    if ( ! SETTINGS.no_default_lib && ! params.static_control ) space.s( 'server_initialized' ).value = true

    space.s( 'load:progress' ).on( progress => loadScene && loadScene.updateProgress && loadScene.updateProgress( progress ) )
    space.s( 'load:progress' )
        .filter( () => loadScene )
        .to( loadscene_space.s( 'progress' ) )

    fix_loading_stuck( space )

    space.s( 'load:complete' )
        .filter( c => c.bundle && c.bundle.name == 'main' )
        .on( c => {
            if ( ! ga_graphics_reported )
            {
                ga_graphics_reported = true
                ga_event( 'graphics_loaded' );
            }

            space.s( 'graphics_loaded' ).next( true )
        } )

    let already_completed = false
    space.s( 'graphics_loaded' )
        .any( space.s( 'server_initialized' ), ( l, i ) => l && i )
        .filter( done => done )
        .on( () => {
            if ( already_completed ) {
                console.warn( 'Loading already completed.' )
                return
            }
            already_completed = true
            
            //adding resources of current stage so that engine may start working right away:
            const adding = SETTINGS.bundles.filter( b => b.types.some( t => server ? ( t == server.type ) : false ) )
            if ( adding.length > 0 ) {
                console.log( 'Preloading', adding, 'resources for stationed state ...' )
                added = true
                space.s( 'load:load' ).next( adding )
            }
            else {
                complete()
            }
        } )

    const complete = () => {
        if ( ! ga_load_reported )
        {
            ga_load_reported = true
            ga_event( 'main_completed' );
            ga_timing( 'main_completed' )
        }
        
        if ( popupScene.hideProcessIndicator ) popupScene.hideProcessIndicator();
        if ( loadScene.hideConnectionIndicator ) loadScene.hideConnectionIndicator();
        if ( loadScene.parent ) loadScene.parent.removeChild( loadScene )
        if ( loadScene.destroy ) loadScene.destroy(true);
        loadScene = null;
        loadscene_space.clear()

        if ( in_iframe() ) window.top.postMessage( "game_loading_end", "*" )

        if ( ! SETTINGS.ui_config ) {
            SETTINGS.ui_config = ( SETTINGS.screen.resolution.width == 1024 ) ? uiConfigDefaultXGA : uiConfigDefaultSVGA
        }
        if ( ! SETTINGS.ui_mobile_config ) {
            SETTINGS.ui_mobile_config = ( SETTINGS.screen.resolution.width == 1024 ) ? uiMobileConfigDefaultXGA : uiMobileConfigDefaultSVGA
        }
        //не знаю нужно ли деление, в рамках одного запуска, интерфейсов на mobile и обычный, но в некоторых местах идёт модификация SETTINGS.ui_config независимо от того как игра запускается (mobile или обычный):
        SETTINGS.ui_config = ( SETTINGS.isMobile && ! SETTINGS.SINGLE_INTERFACE ) ? SETTINGS.ui_mobile_config : SETTINGS.ui_config

        if (!SETTINGS.progressive_jackpot_config) SETTINGS.progressive_jackpot_config = pjConfig;

        if ( params && params.static_control ) params.static_control( space )

        if ( SETTINGS.custom_init ) {
            SETTINGS.custom_init({
                space,
                container : stage,
                server,
                errorDriver,
                popupScene,
            })
            if ( popupScene.addChild ) stage.addChild( popupScene )
        }
        else Init({
            server,
            construct,
            rootContainer : game_container,
            errorView : popupScene,
            uiConfig : SETTINGS.ui_config,
            parent : space,
            uiRootContainer : uiAdaptiveContainer,
            backgroundRootContainer : backgroundAdaptiveContainer,
            params,
        })
    }

    let added = false
    space.s( 'load:complete' )
        .filter( () => added )
        .do( () => added = false )
        .on( complete )

    let graphics = resources.pixi
    if ( ! SETTINGS.custom_init && ! SETTINGS.no_default_lib ) {
        graphics = graphics.concat( getUserInterfaceResources( screenConfig, SETTINGS.isMobile ) )
        if (SETTINGS.isMobile) {
            if (resources.onlyMobile) graphics = graphics.concat(resources.onlyMobile)
        }
        else {
            if (resources.onlyDesktop) graphics = graphics.concat(resources.onlyDesktop)
        }
    }

    space.s( 'load:load' ).next( {
        name : 'main',
        graphics : graphics,
        sounds : COMMON_HOWLER_RESOURCES.concat(resources.howler),
    } )
}

/** iPhone has some bug which causes first time page loading (in case of heavy resources) to stuck without any errors; trying to fix (considering it stuck if can't load 0.1% of resources in 30 seconds) */
function fix_loading_stuck( space )
{
    if ( ! runInIOS ) return

    let loading = false
    let stuck_progress = 0
    let stuck_time
    space.s( 'load:load' ).on( () => {
        loading = true
        stuck_progress = 0
        stuck_time = undefined
    })
    space.s( 'load:progress' ).on( progress => {
        loading = true
        const progress_time = performance.now()
        //if first progress or normal progress:
        if ( ! stuck_time || Math.abs( progress - stuck_progress ) > 0.001 )
        {
            stuck_time = progress_time
            stuck_progress = progress
        }
    })
    space.s( 'load:complete' ).on( () => {
        loading = false
        stuck_progress = 0
        stuck_time = undefined
    })
    setInterval(
        () => {
            if ( ! loading ) return

            const now = performance.now()
            if ( stuck_time && ( now - stuck_time ) > ( 30 * 1000 ) )
            {
                window.location.reload( true )
            }
        },
        1000
    )
}

function initLog()
{
    var htmlElement = document.getElementById('log');

    if (HTMLLOG_ENV && NODE_ENV === 'development') {
        var oldLog = console.log;
        var oldError = console.error;

        var logger = function () {
            
            let append = '-------------------------------------<br />'
            
            for (var i = 0; i < arguments.length; i++) {
                if (typeof arguments[i] == 'object') {
                    //avoid "... cercular structure ..." error:
                    try {
                        append += (JSON && JSON.stringify ? JSON.stringify(arguments[i], undefined, 2) : arguments[i]) + ' ';
                    } catch(e){
                        append += 'some cercular structure was here' + ' '
                    }
                } else {
                    append += arguments[i] + ' ';
                }
            }
            
            htmlElement.innerHTML = append + '<br />' + htmlElement.innerHTML
        };

        console.log = function()
        {
            logger.apply( this, arguments );
            oldLog.apply( this, arguments );
        };
        console.error = function()
        {
            logger.apply( this, arguments );
            oldError.apply( this, arguments );
        };
    }
    else {
        if (htmlElement && htmlElement.parentNode) {
            htmlElement.parentNode.removeChild(htmlElement);
        }
    }
}

function redirect( to )
{
    window.location.replace( to );
}

function no_sleep( stage )
{
    const ns = new NoSleep
    stage.interactive = true
    const enable = () => {
        console.log( 'Enabling NoSleep with PIXI event ...' )
        ns.enable()
        stage.off( 'pointerdown', enable )
    }
    stage.on( 'pointerdown', enable )
}

function tab_visibility( space )
{
    const $tab_visibility = space.s( 'tab_visibility' )
    $tab_visibility.next( true )
    document.addEventListener(
        'visibilitychange',
        () => $tab_visibility.next( document.visibilityState != 'hidden' )
    )
}






// WEBPACK FOOTER //
// ./src/library/boot.es6